import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["value"];
var __jsx = React.createElement;
import React from "react";
import { useSelector } from "react-redux";
import { selectSessionSettings } from "redux/reducers/sessionSettingsReducer";
import Select from "../../shared-components/Select";
import { filterFieldsByMasks } from "../tools";
import { Codes } from "../options";
function Sections(_ref) {
  var value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSelector = useSelector(selectSessionSettings),
    userMask = _useSelector.userMask;
  var filtered = filterFieldsByMasks(Codes, userMask);
  return /*#__PURE__*/React.createElement(Select, _extends({
    options: filtered,
    value: value,
    defaultValue: filtered[0].code,
    label: "Search within"
  }, props));
}
export default Sections;